export default {
    setLoginData(state, v) {
        state.LoginData = v;
    }, 
}